const admin = {
  admin: 'System admin',
  panel_title: 'Admin panel',
  current_versions: 'Current versions',
  build_versions: 'Build versions',
  plugin_build: 'Plugin build',
  plugin_build_info: 'Here you can find the latest plugin build.',
  plugin_version: 'Plugin version',
  download_plugin_build: 'Download build',
  plugin_ui_version:
    'Plugin UI version, separate version with | if multiple version should be active.',
  plugin_ui_version_placeholder: 'Enter Plugin UI version',
  plugin_core_version:
    'Plugin CORE version, separate version with | if multiple version should be active.',
  plugin_core_version_placeholder: 'Enter Plugin CORE version',
  go_back: 'Go back',
  flags: {
    title: 'Flags',
    guest_enabled: 'Enable guest simulations and reviews',
  },
  validation: {
    provide_plugin_ui_version: 'Plugin UI version is required',
    provide_plugin_core_version: 'Plugin CORE version is required',
  },
} as const;

export default admin;
